import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useEffect,
  ReactNode,
} from "react";
import PropTypes from "prop-types";
import { useAppServices } from "hook/services";
import GlobalLoader from "Common/Components/Loader";

interface SubAccountContextType {
  subaccount: Record<string, any>;
  Update: (updates: Record<string, any>) => void;
  clear: () => void;
}

const SubAccountContext = createContext<SubAccountContextType | undefined>(undefined);

SubAccountContext.displayName = "SubAccountContext";

interface SubAccountProviderProps {
  children: ReactNode;
}

function SubAccountProvider({ children }: SubAccountProviderProps) {
  const Service = useAppServices();
  const [subaccount, setSubAccount] = useState<Record<string, any>>({}); // Current logged-in subaccount
  const [loader, setLoader] = useState(true);
const pathname=window.location.pathname
const locationId=pathname.split("/")[2]
  const Update = (updates: Record<string, any>) =>
    setSubAccount((prevSubAccount) => ({ ...prevSubAccount, ...updates }));

  const clear = () => {
    setSubAccount({});
  };

  const value = useMemo(
    () => ({
      subaccount,
      Update,
      clear,
    }),
    [subaccount, Update, clear]
  );

  const getSubAccount = async () => {
    const token = localStorage.getItem("token");
    const { response } = await Service.sub_account.get({
      query: `_id=${locationId}`,
      token,
    });
    if (response) setSubAccount({ ...response.data, token });
    return setLoader(false);

  };
  let pageLoad = true;
  const onLoad = () => {
    if (pageLoad) {
      getSubAccount();
      pageLoad = false;
    }
  };

  useEffect(onLoad, []);

  return loader ? (
    <GlobalLoader/>
  ) : (
    <SubAccountContext.Provider value={value}>{children}</SubAccountContext.Provider>
  );
}

function useSubAccountInfo() {
  const [tempsubaccount, setTempSubAccount] = useState<Record<string, any>>({}); // Current logged-in subaccount
  const context = useContext(SubAccountContext) || tempsubaccount;
  if (!context) {
    throw new Error("useSubAccountInfo must be used within a SubAccountProvider");
  }
  return context;
}

SubAccountProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { SubAccountProvider, useSubAccountInfo };
